export default {
    data() {
        return {
            notificationSystem: {
                options: {
                    success: {
                        position: "bottomRight",
                    },
                    error: {
                        position: "bottomRight",
                    },
                },
            }
        }
    },
    methods: {
        /**
         * displays vue izitoast notification in either green (success) or red (error)
         * on bottom left corner
         * 
         * @param {number} flag determines success (falsy) or error (truthy) case
         * @param {string} succMsg success case text
         * @param {string} errMsg error case text
         * @param {object} toast toast object determining styling of notification
        */
        notify(flag, succMsg, errMsg, toast) {
            // success case
            if (!flag) {
                toast.success(
                    succMsg,
                    `OK`,
                    this.notificationSystem.options.success
                );
                // error case
            } else {
                toast.error(
                    errMsg,
                    `Ooops`,
                    this.notificationSystem.options.error
                );
            }
        },
        /**
         * displays vue izitoast notification in yellow
         * on bottom left corner
         * 
         * @param {string} msg message
         * @param {object} toast toast object determining styling of notification
        */
        report(msg, toast) {
            toast.info(
                msg,
                `Hinweis`,
                this.notificationSystem.options.success
            );

        },
    },
}

